"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Logger_1 = __importDefault(require("../Logger"));
var Pool_1 = __importDefault(require("../Pool"));
var Connection_1 = require("../Connections/Connection");
var Test_1 = __importStar(require("./Test"));
var MeasureTest = /** @class */ (function (_super) {
    __extends(MeasureTest, _super);
    function MeasureTest(serverUrl, ticket, pool) {
        var _this = _super.call(this) || this;
        _this.connections = {};
        _this.loaded = 0;
        _this.interval = 100;
        _this.wantedConnections = 1;
        _this.maxErrors = 3;
        _this.testTime = 10000;
        _this.onClose = function (id, e) {
            if (!(id in _this.connections) || !_this.connections[id]) {
                Logger_1.default.log("Received close event for ".concat(id, " but the connection doesn't exist"));
                return;
            }
            var bufferedAmount = _this.connections[id].bufferedAmount();
            Logger_1.default.log("web channel ".concat(id, " closed, close reason: ").concat(e.reason, " close code: ").concat(e.code, " buffered amount: ").concat(bufferedAmount));
            _this.removeConnection(id);
        };
        // eslint-disable-next-line no-unused-vars
        _this.onOpen = function (id) {
            if (_this.completed) {
                return;
            }
            if (!(id in _this.connections) || !_this.connections[id]) {
                _this.removeConnection(id);
                return;
            }
            if (_this.connections[id].readyState() === 1) {
                _this.handleOpen(id);
            }
            else {
                _this.pool.remove(id);
            }
        };
        // eslint-disable-next-line no-unused-vars
        _this.onMessage = function (id, e) {
            if (_this.completed) {
                _this.removeConnection(id);
                return;
            }
            if (!(id in _this.connections) || !_this.connections[id]) {
                _this.removeConnection(id);
                return;
            }
            if (!_this.started) {
                _this.startTimer();
            }
            _this.handleMessage(id, e);
        };
        _this.onError = function (id, e) {
            if (!(id in _this.connections) || !_this.connections[id]) {
                Logger_1.default.log("Received error event for ".concat(id, " but the connection doesn't exist"));
                return;
            }
            _this.errors.push({ id: id, error: e.code });
            Logger_1.default.log("web channel ".concat(id, " closed, error reason: ").concat(e.reason, " error code: ").concat(e.code));
            _this.removeConnection(id);
            if (_this.errors.length > _this.maxErrors) {
                _this.abort(true);
            }
        };
        _this.tick = function () {
            if (_this.completed || !_this.started) {
                return;
            }
            var time = _this.passedTime;
            var _a = _this, testTime = _a.testTime, openConnections = _a.openConnections;
            // If no open connections and time has passed 9.65 seconds
            // consider the test completed
            if ((time > (testTime - 51) && openConnections < 1) || time > (testTime + 1000)) {
                _this.done();
                return;
            }
            // Average speed
            var bps = (1020.0 * _this.loaded) / time;
            // Update speed if less than half a second left or speed is more than last update
            if (time < (testTime - 500) || bps > _this.result) {
                _this.result = bps;
            }
            _this.progress(_this.result);
            _this.onTick(bps);
        };
        _this.serverUrl = serverUrl;
        _this.ticket = ticket;
        _this.pool = pool;
        return _this;
    }
    Object.defineProperty(MeasureTest.prototype, "openConnections", {
        get: function () {
            return Object.keys(this.connections).length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeasureTest.prototype, "passedTime", {
        get: function () {
            if (!this.startTime) {
                return 0;
            }
            return (new Date()).getTime() - this.startTime;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MeasureTest.prototype, "timeLeft", {
        get: function () {
            var time = this.passedTime;
            return (this.testTime - time) / 1000;
        },
        enumerable: false,
        configurable: true
    });
    MeasureTest.prototype.createConnections = function (type) {
        if (this.wantedConnections === 0) {
            return;
        }
        Logger_1.default.log("Creating new connections. Wants: ".concat(this.wantedConnections, ". Open: ").concat(this.openConnections));
        if (this.wantedConnections === this.openConnections) {
            Logger_1.default.log('No need to create more connections');
            return;
        }
        while (this.openConnections < this.wantedConnections) {
            this.createConnection(type);
        }
    };
    MeasureTest.prototype.createConnection = function (type) {
        var _this = this;
        var connection = this.pool.reserve(type);
        this.connections[connection.id] = connection;
        connection.on(Connection_1.ConnectionEvents.OPEN, this.onOpen);
        connection.on(Connection_1.ConnectionEvents.MESSAGE, this.onMessage);
        connection.on(Connection_1.ConnectionEvents.CLOSE, this.onClose);
        connection.on(Connection_1.ConnectionEvents.ERROR, function (id, error) {
            Logger_1.default.log("Connection ".concat(id, " failed"), error);
            _this.pool.remove(id);
        });
        connection.ready();
    };
    MeasureTest.prototype.setNoConnections = function (no, dispatch) {
        if (dispatch === void 0) { dispatch = false; }
        if (this.completed) {
            return;
        }
        this.wantedConnections = no;
        if (dispatch) {
            this.createConnections();
        }
    };
    MeasureTest.prototype.removeConnection = function (id, wait) {
        if (wait === void 0) { wait = false; }
        Logger_1.default.log("Test removes ".concat(id));
        delete this.connections[id];
        if (!wait) {
            this.pool.release(id);
        }
        this.createConnections();
    };
    MeasureTest.prototype.progress = function (current) {
        this.emit(Test_1.TestEvents.PROGRESS, {
            testName: this.name,
            current: current,
            progress: this.passedTime / this.testTime,
        });
    };
    // eslint-disable-next-line class-methods-use-this,no-unused-vars
    MeasureTest.prototype.handleOpen = function (id) {
        // override in test
    };
    // eslint-disable-next-line class-methods-use-this,no-unused-vars
    MeasureTest.prototype.handleMessage = function (id, e) {
        // override in test
    };
    MeasureTest.prototype.startTimer = function () {
        this.startTime = (new Date()).getTime();
        this.started = true;
        this.timer = setInterval(this.tick, this.interval);
    };
    MeasureTest.prototype.cleanup = function () {
        var _this = this;
        this.setNoConnections(0);
        Object.keys(this.connections).forEach(function (id) {
            _this.pool.release(id);
            delete _this.connections[id];
        });
    };
    // eslint-disable-next-line max-len
    // eslint-disable-next-line class-methods-use-this,no-unused-vars, @typescript-eslint/no-unused-vars
    MeasureTest.prototype.onTick = function (bps) {
        // override in subclass
    };
    MeasureTest.prototype.reportResult = function () {
        this.emit(Test_1.TestEvents.RESULT, {
            testName: this.name,
            result: this.result,
            warnings: this.warnings,
            errors: this.errors,
        });
    };
    return MeasureTest;
}(Test_1.default));
exports.default = MeasureTest;
//# sourceMappingURL=MeasureTest.js.map